import React, { useEffect, useRef, useState } from "react";
import { FaCamera } from "react-icons/fa";
import Input from "../Input/Input";
import AuthButton from "../AuthButton/AuthButton";
import DropDownComponent from "../DropDown/DropDown";
import { useSelector } from "react-redux";
import DropDownCustom from "../DropDownCustom/DropDownCustom";
import { useDispatch } from "react-redux";
import { UploadImage, getAdminbyid, getClientbyid, updateAdmin, updateClient } from "../../Actions/actions";
import Loader from "../Loader/Loader";
import GoogleMapsWrapper from "../Input/AddressInput";

const colorTheme = [{ label: "Red" }, { label: "Blue" }, { label: "Green" }];
const fontStyle = [
  { label: "Bold" },
  { label: "Regular" },
  { label: "SemiBold" },
];
const languages = [
  { label: "English" },
  { label: "Urdu" },
  { label: "Arabic" },
];
const currency = [{ label: "AED" }, { label: "PKR" }, { label: "USD" }];

const CompanyProfile = () => {
  const { role, loginData, singleClient, subLoader, singleAdmin } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch()
  const [selectedTheme, setSelectedTheme] = useState(colorTheme[0]);
  const [selectedFontStyle, setSelectedFontStyle] = useState(fontStyle[0]);
  const [selectedLanguage, setSelectedLanguage] = useState(languages[0]);
  const [selectedCurrency, setSelectedCurrency] = useState(currency[0]);
  const [errors, setErrors] = useState({});
  const [companyname, setcompanyname] = useState('');


  const [logo, setLogo] = useState(null);
  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    businessName: '',
    businessWhatsapp: '',
    businessAddress: '',
    logo: '',
    clientIndustry: '',
    businessCountryCode: ''


  });
  useEffect(() => {
    if (role == 'Admin')
      dispatch(getAdminbyid(loginData?.accessToken, loginData?.userId, () => { }))
    else {
      dispatch(getClientbyid(loginData?.accessToken, loginData?.clientData?.id, () => { },
      () => { }))
    }
  }, [])
  useEffect(() => {
    if (role == 'Admin') {
      setcompanyname(singleAdmin?.firstname)
      setLogo(singleAdmin?.logo)
    }
    else {
      setFormData({
        businessName: singleClient?.businessName ? singleClient?.businessName : "",
        businessWhatsapp: singleClient?.businessWhatsapp ? singleClient?.businessWhatsapp : "",
        businessAddress: singleClient?.businessAddress ? singleClient?.businessAddress : "",
        logo: singleClient?.logo ? singleClient?.logo : '',
        clientIndustry: singleClient?.clientIndustry ? singleClient?.clientIndustry : '',
        businessCountryCode: singleClient?.businessCountryCode ? singleClient?.businessCountryCode : ""



      });
    }
  }, [singleClient, singleAdmin]);
  console.log(formData, 'formdata');
  console.log(singleClient, singleAdmin, 'singleclients');

  const validateForm = () => {
    let newErrors = {};
    if (!formData.businessName) {
      newErrors.businessName = "Company Name is required";
    }
    if (!formData.businessWhatsapp) {
      newErrors.businessWhatsapp = "Contact Number is required";
    }
    if (!formData.businessAddress) {
      newErrors.businessAddress = "Company Address is required";
    }
    // if (!formData.clientIndustry) {
    //   newErrors.clientIndustry = "Client Industry is required";
    // }
    console.log(newErrors, 'h');
    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const handleNext = (e) => {
    e.preventDefault();
    if (validateForm()) {
      dispatch(updateClient(singleClient?.id, formData, loginData?.accessToken, () => {
      }))
    }
  };
  const handleLogoClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      console.log('hammad');
      dispatch(UploadImage(file, loginData?.accessToken, (data) => {
        setFormData({ ...formData, logo: data.data.fileUrl })
        setLogo(data.data.fileUrl);
      }))
    }
  };
  const clientIndustryOptions = [
    { label: "Technology", value: "Technology" },
    { label: "IT Consultant", value: "IT Consultant" },
    { label: "Manufacture", value: "Manufacture" },
  ];
  return (
    <>
      {role == "Client" ? (
        <div className="flex md:space-x-8 sm:space-y-8 sm:flex-col md:flex-row  ">
          <div className="sm:w-full md:w-2/5 bg-white p-2 sm:py-10 md:py-0 rounded-lg shadow-lg flex flex-col  items-center justify-center">
            <div className="rounded-full bg-gray-200 mb-4 relative"
              onClick={handleLogoClick}

            >
              <img
                src={
                  logo
                    ? logo
                    : singleClient?.logo || "https://via.placeholder.com/150"
                } className="w-36 h-36 object-cover rounded-full bg-gray-200 shadow-md "
              />
              {logo || singleClient?.logo ? null :
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                  <FaCamera className="w-7 h-7 mb-1" />
                  <p className="text-black text-sm text-center">Upload Logo</p>
                </div>}
              <input
                type="file"
                ref={fileInputRef}
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleLogoUpload}
              />
            </div>

            <p className="text-gray-500 text-sm text-center">
              Allowed *.jpeg, *.jpg, *.png            </p>
          </div>

          <div className="sm:w-full  md:w-3/5 bg-white p-8 rounded-lg shadow-lg">
            <form className="">
              <div className="grid grid-cols-1  xl:grid-cols-2 gap-6 mb-6 ">
                <div>
                  <Input
                    type="text"
                    float
                    label={"Company Name"}
                    placeholder="Company Name"
                    value={formData.businessName}
                    onChange={(e) => {
                      setFormData({ ...formData, businessName: e.target.value })
                      setErrors({ ...errors, businessName: '' })
                    }
                    }
                    error={errors.businessName}
                  />
                </div>
                <div>
                  <Input
                    isPhoneNumber
                    countryCodeValue={formData?.businessCountryCode}
                    onCountryChange={(newCountryCode) => {
                      setFormData((prev) => ({
                        ...prev,
                        businessCountryCode: newCountryCode,
                      }));
                    }}
                    float
                    placeholder="Contact Number"
                    value={formData.businessWhatsapp}
                    onChange={(e) => {
                      setFormData({ ...formData, businessWhatsapp: e.target.value })
                      setErrors({ ...errors, businessWhatsapp: '' })
                    }
                    }
                    error={errors.businessWhatsapp}
                  />
                </div>
              </div>
              <div className="mb-2">
                <GoogleMapsWrapper
                  errors={errors}
                  setErrors={setErrors}
                  formData={formData}
                  setFormData={setFormData}
                />
                {/* <Input
                  float
                  type="text"
                  placeholder="Company Address"
                  value={formData.businessAddress}
                  onChange={(e) => {
                    setFormData({ ...formData, businessAddress: e.target.value })
                    setErrors({ ...errors, businessAddress: '' })
                  }
                  }
                  error={errors.businessAddress} /> */}
              </div>
              <div className="mb-6">
                <DropDownCustom
                  selectedValue={clientIndustryOptions?.find(option => option.label === formData.clientIndustry)}
                  handleChanges={(option) => {
                    setFormData({ ...formData, clientIndustry: option.label });
                    setErrors({ ...errors, clientIndustry: '' });
                  }}
                  options={clientIndustryOptions}
                  isSearchable={false}
                  label="Client Industry"
                  placeholder="Select Industry"
                />
              </div>

              <div className="flex justify-end">
                {subLoader ?
                  <Loader /> :
                  <AuthButton
                    width={"20%"}
                    title={"Save Changes"}
                    className="px-4 py-2  text-white rounded-md"
                    onClick={(e) => {
                      handleNext(e)
                    }}

                  />
                }
              </div>
            </form>
          </div>
        </div>
      ) : (
        <div className="flex md:space-x-8 sm:space-y-8 sm:flex-col md:flex-row  ">
          <div className="sm:w-full md:w-2/5 bg-white p-2 sm:py-10 md:py-0 rounded-lg shadow-lg flex flex-col  items-center justify-center">
            <div className="rounded-full bg-gray-200 mb-4 relative"
              onClick={handleLogoClick}

            >
              <img
                src={
                  logo
                    ? logo
                    : singleClient?.logo || "https://via.placeholder.com/150"
                } className="w-36 h-36 object-cover rounded-full bg-gray-200 shadow-md "
              />
              {logo || singleClient?.logo ? null :
                <div className="absolute inset-0 flex flex-col items-center justify-center">
                  <FaCamera className="w-7 h-7 mb-1" />
                  <p className="text-black text-sm text-center">Upload Logo</p>
                </div>}
              <input
                type="file"
                ref={fileInputRef}
                accept="image/*"
                style={{ display: "none" }}
                onChange={handleLogoUpload}
              />
            </div>

            <p className="text-gray-500 text-sm text-center">
              Allowed *.jpeg, *.jpg, *.png
            </p>
          </div>
          <div className="sm:w-full  md:w-3/5 bg-white p-8 rounded-lg shadow-lg">
            <form className="space-y-6">
              <Input
                float
                label={"Company Name"}
                // placeholder="Company Name"
                className="mt-[-23px]"
                value={companyname}
                onChange={(e) => {
                  setcompanyname(e.target.value)
                  // setErrors({ ...errors, businessAddress: '' })
                }}
              />
              {companyname == '' && (
                <p className="text-red-500 text-sm mt-1">Company Name is required</p>
              )}
              {/* <div className="flex flex-wrap w-full gap-4">
                <div className="w-[48%]">
                  <DropDownCustom
                    isClient={true}
                    data={colorTheme}
                    onChange={setSelectedTheme}
                    value={selectedTheme.label}
                    className="sm:w-full md:w-1/2 lg:w-1/4"
                    label="Color Theme"
                    isSearchable={false}
                  />
                </div>
                <div className="w-[48%]">
                  <DropDownCustom
                    isClient={true}
                    data={fontStyle}
                    onChange={setSelectedFontStyle}
                    value={selectedFontStyle.label}
                    className="sm:w-full md:w-1/2 lg:w-1/4"
                    label="Font Style"
                    isSearchable={false}

                  />
                </div>
              </div>

              <div className="flex flex-wrap w-full gap-4">
                <div className="w-[48%]">
                  <DropDownCustom
                    isClient={true}
                    data={languages}
                    onChange={setSelectedLanguage}
                    value={selectedLanguage.label}
                    className="sm:w-full md:w-1/2 lg:w-1/4"
                    label="Language"
                    isSearchable={false}
                  />
                </div>
                <div className="w-[48%]">
                  <DropDownCustom
                    isClient={true}
                    data={currency}
                    onChange={setSelectedCurrency}
                    value={selectedCurrency.label}
                    className="sm:w-full md:w-1/2 lg:w-1/4"
                    label="Currency"
                    isSearchable={false}
                  />
                </div>
              </div> */}
              <div onClick={(e) => {
                e.preventDefault();

                console.log(logo);
                dispatch(
                  updateAdmin(loginData?.userId, {
                    logo: logo,
                    companyname: companyname
                  }, loginData?.accessToken, () => {
                    dispatch(getAdminbyid(loginData?.accessToken, singleAdmin?.userId, () => { }));

                  })
                );
              }} className="flex justify-end">
                <AuthButton title="Save Changes" className="text-white"
                />
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default CompanyProfile;
